<template>
  <div>
    <div
      class="d-flex align-items-center p-2">
      <span
        class="notifications-heading-mark mr-1"
        :class="{'notifications-heading-mark--marked': notification.comment.activityResult.star}" />
      <span
        v-if="notification.comment.activityResult.isLocked"
        class="material-icons goal-lock-icon">
        lock
      </span>

      <TemplateColorChip :color="notification.comment.activityResult.templateColor" />
      <h3 class="notifications__heading">
        {{ notification.comment.activityResult.name }}
      </h3>
    </div>
    <div
      @click="onClickActivePart">
      <div class="comment p-2">
        <div
          class="comment__item">
          <div class="comment__head d-flex align-items-center justify-content-between mb-2">
            <div class="comment__content d-flex align-items-center">
              <User :user="notification.comment.createdBy">
                <p class="comment__date">
                  {{ notification.comment.createdAt | prettyDateTime }}
                </p>
              </User>
            </div>
          </div>
          <div class="comment__body">
            <p>{{ notification.comment.detail | emptyChar("[添付ファイルのみ]") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/components/parts/User.vue'
import TemplateColorChip from '@/components/parts/TemplateColorChip.vue'

export default {
  components: {
    User,
    TemplateColorChip,
  },
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      checked: false,
    }
  },
  methods: {
    async onClickActivePart() {
      this.$emit('click-notification', this.notification.id)
    },
  }
}
</script>

<style lang="scss" scoped>
.notifications-heading-mark {
  height: 12px;
  width: 12px;
  border-radius: 50%;
  background: $grey16;
  &--marked {
    background: $pink;
  }
}

.notifications{
  &__heading{
    font-size: $fs-nm;
    font-weight: bold;
    position: relative;
  }
}

.comment{
  &__item {
    background-color: $grey15;
    padding: 8px;
  }

  &__date{
    font-size: $fs-m;
  }
  &__body{
    white-space:pre-wrap;
    word-wrap:break-word;
    color: $grey04;
  }
}

</style>